import type { PanelFilters, PolicyFilterOption } from '@content-search/domain';
import { POLICY_FILTER_LABELS } from '@content-search/domain';
import { Select } from '@soteria/design-system-ve';
import { useCallback } from 'react';

import * as styles from './FilterPanel.css';

interface PolicyFilterProps {
  panelFilters: PanelFilters;
  updateFilters: (updates: Partial<PanelFilters>) => void;
  isLoading: boolean;
}

const POLICY_FILTER_OPTIONS: Array<{
  value: PolicyFilterOption | 'all';
  label: string;
}> = [
  { value: 'all', label: POLICY_FILTER_LABELS.all },
  { value: 'compliant', label: POLICY_FILTER_LABELS.compliant },
  { value: 'violations', label: POLICY_FILTER_LABELS.violations },
];

// Transform policy options for Select component
const getPolicyFilterSelectOptions = () =>
  POLICY_FILTER_OPTIONS.map(option => ({
    id: option.value,
    label: option.label,
    value: option.value,
  }));

export function PolicyFilter({ panelFilters, updateFilters, isLoading }: PolicyFilterProps) {
  const handlePolicyFilterChange = useCallback(
    (selectedValue: string) => {
      const policyFilter = selectedValue === 'all' ? undefined : (selectedValue as PolicyFilterOption);

      updateFilters({ policyFilter });
    },
    [updateFilters]
  );

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterLabel}>Policy Response</div>
      <Select
        aria-label="Filter by policy response"
        disabled={isLoading}
        options={getPolicyFilterSelectOptions()}
        placeholder="All Content"
        value={panelFilters.policyFilter || 'all'}
        onChange={handlePolicyFilterChange}
      />
    </div>
  );
}
